<template>
  <div class="feature-row row g-4 g-lg-5 align-items-center" :class="{ 'feature-row--reversed': reversed }">
    <div class="feature-row__content col-lg-6">
      <p v-if="eyebrow" class="feature-row__eyebrow mb-3">{{ eyebrow }}</p>
      <h3 class="feature-row__title mb-3">{{ title }}</h3>
      <p class="feature-row__body mb-3">{{ body }}</p>
      <p v-if="highlight" class="feature-row__highlight mb-4">{{ highlight }}</p>
      <RouterLink v-if="cta" :to="cta.to" class="nm-btn nm-btn--ghost nm-btn--sm">
        {{ cta.label }}
        <i class="fa-solid fa-arrow-right" aria-hidden="true" />
      </RouterLink>
    </div>
    <div class="feature-row__visual col-lg-6">
      <CardSurface raised pad="md" class="feature-row__panel h-100">
        <div class="feature-row__visual-inner text-center">
          <div class="feature-row__icon mb-4">
            <i :class="visual.icon" aria-hidden="true" />
          </div>
          <p class="feature-row__visual-label mb-0">{{ visual.label }}</p>
        </div>
      </CardSurface>
    </div>
  </div>
</template>

<script setup>
import CardSurface from '@/components/CardSurface.vue'

defineProps({
  eyebrow: { type: String, default: '' },
  title: { type: String, required: true },
  body: { type: String, required: true },
  highlight: { type: String, default: '' },
  cta: { type: Object, default: null },
  visual: { type: Object, required: true },
  reversed: { type: Boolean, default: false },
})
</script>

<style scoped>
@media (min-width: 992px) {
  .feature-row--reversed .feature-row__content {
    order: 2;
  }

  .feature-row--reversed .feature-row__visual {
    order: 1;
  }
}

.feature-row__eyebrow {
  font-size: 0.78rem;
  font-weight: var(--nm-font-weight-semibold);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--nm-accent);
}

.feature-row__title {
  font-size: clamp(1.35rem, 3vw, 1.85rem);
  font-weight: var(--nm-font-weight-bold);
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.feature-row__body {
  font-size: 1rem;
  color: var(--nm-text-muted);
  line-height: 1.7;
  margin-bottom: 0;
}

.feature-row__highlight {
  font-size: 0.95rem;
  font-weight: var(--nm-font-weight-medium);
  color: var(--nm-accent-glow);
  line-height: 1.6;
  padding-left: 1rem;
  border-left: 2px solid rgba(184, 180, 232, 0.35);
}

.feature-row__panel {
  min-height: 16rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-row__icon {
  width: 4.5rem;
  height: 4.5rem;
  margin-inline: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--nm-surface-inset);
  box-shadow: var(--nm-inset-md);
  color: var(--nm-accent-glow);
  font-size: 1.65rem;
}

.feature-row__visual-label {
  font-size: 0.85rem;
  font-weight: var(--nm-font-weight-medium);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--nm-text-secondary);
}
</style>